import styled from 'styled-components';
import { LayoutProps, layout, MarginProps, margin, PaddingProps, padding, TypographyProps, typography } from 'styled-system';
import { EMPTY_STRING, HTML_LINE_BREAK} from '../../constants/data';

type Props = {
    text?: string;
} & StyledTextProps;

export const SlideText = (props: Props) => {
    const {text, ...otherProps } = props;
    const hasText: boolean = !!text && text.trim().length > 0;
    const accesibilityText = getAccessibilityText(text);
    const tabIndex = hasText ? 0 : -1;

    return (
        <StyledText
            dangerouslySetInnerHTML={getMarkup(text)}       
            width={['auto']}
            title={accesibilityText}
            aria-label={accesibilityText}
            role={"link"}
            tabIndex={tabIndex}
            display={hasText ? 'block' : 'none'}
            textAlign="left"
            {...otherProps} />
    );
}

/** Devuelve el texto que será interpretado por el lector de pantalla */
function getAccessibilityText(originalText?: string): string | undefined {
    return originalText?.replace(HTML_LINE_BREAK, EMPTY_STRING);
}
/** Formato que utiliza React para cargar html plano */
function getMarkup(text?: string) {
    return { __html: text ?? '' };
}

type StyledTextProps = LayoutProps & TypographyProps & MarginProps & PaddingProps;
const StyledText = styled.div<StyledTextProps>(
  layout,
  typography,
  margin,
  padding
);
  